export default __webpack_public_path__ + "static/media/ellipsis_light.19eaa7d3.svg";